import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { ACCOUNT_ID } from '../../fields';
import { ACCOUNT_VIDEO_REPORT_ID } from './accountVideoReportId';

const accountReportFooterColumnDefinition = [ACCOUNT_ID].map(createFooterMapper(ACCOUNT_VIDEO_REPORT_ID));

export default accountReportFooterColumnDefinition;
